import { Badge, type BadgeTone } from './badge'
import type { FreightStatus } from '@/types/freight'

const STATUS_CONFIG: Record<FreightStatus, { label: string; tone: BadgeTone }> = {
  PENDING: { label: 'Pendente', tone: 'warning' },
  ASSIGNED: { label: 'Atribuído', tone: 'info' },
  IN_TRANSIT: { label: 'Em trânsito', tone: 'purple' },
  DELIVERED: { label: 'Entregue', tone: 'teal' },
  PROOF_RECEIVED: { label: 'Canhoto recebido', tone: 'indigo' },
  COMPLETED: { label: 'Concluído', tone: 'success' },
}

interface FreightStatusBadgeProps {
  readonly status: FreightStatus
  readonly className?: string
}

export function FreightStatusBadge({ status, className }: FreightStatusBadgeProps) {
  const config = STATUS_CONFIG[status] ?? { label: status, tone: 'neutral' as const }
  return (
    <Badge tone={config.tone} className={className}>
      {config.label}
    </Badge>
  )
}
